import { SxProps } from "@mui/material";

export const bvSectionSx:SxProps = {
    '& *':{
        bgcolor:'#fff !important'
    }
}